// See backend getAvailableCoachPlans.ts

// February 13, 2024
export const LAUNCH_DISCOUNT_CUTOFF_DATE = '2024-02-13';
